import { useContext } from "react"
import promoContext from "../contexts/promoContext"

const usePromoContext = () => useContext(promoContext)

export default usePromoContext